import { GroCommon } from './common';
import { setDropdown } from './form-controls';

const DateUtils = {
    toISOString(date) {
        return date.toISOString().split('T')[0];
    },

    addDays(date, days) {
        const newDate = new Date(date);
        newDate.setDate(date.getDate() + days);
        return newDate;
    },

    parseDate(dateString) {
        return new Date(dateString);
    },

    formatShortDate(date) {
        return date.toShortDateString();
    },

    validateDateRange(fromDate, toDate, maxDays = 90) {
        const start = new Date(fromDate);
        const end = new Date(toDate);
        const daysDiff = (end - start) / (24 * 60 * 60 * 1000);
        return daysDiff <= maxDays;
    },

    getDefaultDateRange() {
        const today = new Date();
        return {
            toDate: this.toISOString(today),
            fromDate: this.toISOString(this.addDays(today, -30))
        };
    }
};

export let TimeBookingFunction = (function () {
        var blockUI = function () {
            $('#loader').show();
        };
        var unBlockUI = function () {
            $('#loader').hide();
        };
        var fillContentToModal = function (dialogId, header, content, openDialog, dialogType) {
            var $dialogArea = $(dialogId);
            var $iconElement = $dialogArea.find('span.popup-type');
            if (dialogType) {
                $iconElement.removeClass('hidden');
                $iconElement.addClass(GroCommon.getModalIconClass(dialogType));
            } else {
                $iconElement.addClass('hidden');
            }

            $dialogArea.find('.lm__wide-modal__title').html(header);
            $dialogArea.find('p').append(content);
            $dialogArea.find('.btn-ok').on('click', function () {
                $dialogArea.addClass('hidden');
            });
            if (openDialog) {
                $dialogArea.removeClass('hidden');
            }
        };
        var clearContentToModal = function (dialogId) {
            var dialogArea = $(dialogId);
            dialogArea
                .find('span.alert-icon.popup-type')
                .removeClass('warning -info-circle success');
            dialogArea.find('.lm__wide-modal__title').html('');
            dialogArea.find('p').html('');
            dialogArea.find('.btn-ok').unbind('click');
        };
        var fillContentToDeleteDialog = function (header, content) {
            var dialogArea = $('#deleteDialog');
            dialogArea.find('.modal-header-title').html(header);
            dialogArea.find('p').append(content);
            dialogArea.find('.btn-cancel').on('click', function () {
                dialogArea.hide();
            });
            dialogArea.find('.btn-ok').on('click', function () {
                dialogArea.hide();
            });
            dialogArea.show();
        };
        var clearContentToDeleteDialog = function () {
            var dialogArea = $('#deleteDialog');
            dialogArea.find('.lm__wide-modal__title').html('');
            dialogArea.find('p').html('');
            dialogArea.find('.btn-ok').unbind('click');
            dialogArea.find('.btn-cancel').unbind('click');
        };
        var copyValuesToEnableEdit = function (editObj, listTimebooking) {
            $('#displayMessageHeader').html(
                'Ändra bokning genom att ändra uppgifter nedan och klicka Uppdatera bokning.'
            );
            $('#myDisplayMessage').html(editObj.displayMessage);
            $('#IDLevnr').val(editObj.idLevnr);
            $('#IDReg').val(editObj.idReg);
            $('#IDOvrigt').val(editObj.idOvrigt);
            $('#IDEpost').val(editObj.idEpost);
            $('#IDMobil').val(editObj.idMobil);
            $('#saveAction').val('Update');
            $('#ReservationID').val(editObj.reservationId);
            $('#SpeditorNo_ForUpdate').val(editObj.speditorNo);
            $('#CustomerNo_ForUpdate').val(editObj.customerNo);
            $('#CustomerName_ForUpdate').val(editObj.customerName);
            $('#newCustomerNo').val(editObj.customerNo);
            $('#newCustomerName').val(editObj.customerName);

            var reminder = $('#IDReminder');
            if (editObj.idReminder === '0' || editObj.idReminder === '') {
                reminder.attr('data-value', '');
                reminder.find('input[name="IDReminder"]').val('');
                reminder.find('>a').html('Ingen påminnelse');
            } else {
                reminder.attr('data-value', editObj.idReminder);
                reminder.find('input[name="IDReminder"]').val(editObj.idReminder);
                var subReminder = reminder.find('ul > li[data-value="' + editObj.idReminder + '"]');
                var valueSubReminder = subReminder.find('a').html();
                subReminder.addClass('selected');
                reminder.find('>a').html(valueSubReminder);
            }
            $('#TransportOrderNo_ForUpdate').val(editObj.transportOrderNo);
            $('#ContractNo_ForUpdate').val(editObj.contractNo);
            $('#ReminderEmail_ForUpdate').val(editObj.reminderEmail);
            $('#ReminderSMS_ForUpdate').val(editObj.reminderSms);
            $('#Owner').val(editObj.owner);
            $('#SaveTable').show();
            if (listTimebooking == false) {
                $('#DateRegistered').val(editObj.dateRegistered);
                $('#saveBtn').hide();
                $('#newCustomerNo').removeAttr('disabled');
                $('input:checkbox').attr('checked', false);
                $('#updateBtn').show();
            } else {
                $('#DateRegisteredList').val(editObj.dateRegistered);
                if ($('#CustomerName_ForUpdate').val() != editObj.customerName) {
                    alert('fel');
                }
                $('#updateListBtn').show();
                $('html, body').animate(
                    {
                        scrollTop: $('#updateListBtn').offset().top,
                    },
                    1000
                );
            }
        };
        var validateSaveTable = function (email, phone, regnr, levnr) {
            var reEmail =
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var rePhone = /^\+?(\d[\d-. ]+)?(\([\d-. ]+\))?[\d-. ]+\d$/;
            var reRegnr = /^([a-zA-Z]{3}\d{3})+$/;
            var reLevnr = /^[a-zåäö0-9]+$/i;
            var result = true;
            TimeBookingFunction.clearValidateSaveTable();

            var reminder = $('#IDReminder').attr('data-value');

            if (email !== '' && !reEmail.test(email)) {
                result = false;
                $('#IDEpost').addClass('error');
                $('#IDEpost-error').show();
            }

            if (phone !== '' && !rePhone.test(phone)) {
                result = false;
                $('#IDMobil').addClass('error');
                $('#IDMobil-error').show();
            }
            if (!regnr) {
                result = false;
                $('#IDReg').addClass('error');
                $('#IDReg-error').show();
            }
            if (!reLevnr.test(levnr)) {
                result = false;
                $('#IDLevnr').addClass('error');
                $('#IDLevnr-error').show();
            }

            if (reminder && reminder !== '0' && phone === '' && email === '') {
                result = false;
                $('#IDEpost-IDMobil-error').show();
                $('#IDEpost').addClass('error');
                $('#IDMobil').addClass('error');
            }
            return result;
        };
        var clearValidateSaveTable = function () {
            $('#IDEpost-error').hide();
            $('#IDMobil-error').hide();
            $('#IDLevnr-error').hide();
            $('#IDReg-error').hide();
            $('#IDEpost').removeClass('error');
            $('#IDMobil').removeClass('error');
            $('#IDReg').removeClass('error');
            $('#IDLevnr').removeClass('error');
            $('#IDEpost-IDMobil-error').hide();
        };
        return {
            blockUI: blockUI,
            unBlockUI: unBlockUI,
            fillContentToModal: fillContentToModal,
            clearContentToModal: clearContentToModal,
            fillContentToDeleteDialog: fillContentToDeleteDialog,
            clearContentToDeleteDialog: clearContentToDeleteDialog,
            copyValuesToEnableEdit: copyValuesToEnableEdit,
            validateSaveTable: validateSaveTable,
            clearValidateSaveTable: clearValidateSaveTable,
        };
    })();

var BookingStatus =
    BookingStatus ||
    (function () {
        var unplanned = function () {
            return 'Unplanned';
        };

        var notfound = function () {
            return 'NotFound';
        };

        var delivered = function () {
            return 'Delivered';
        };
        var reservationExists = function () {
            return 'ReservationExists';
        };
        return {
            NotFound: notfound,
            Unplanned: unplanned,
            Delivered: delivered,
            ReservationExists: reservationExists,
        };
    })();

var ReferenceType =
    ReferenceType ||
    (function () {
        var purchaseOrder = function () {
            return '5';
        };
        var customerOrder = function () {
            return '6';
        };
        var distributionOrder = function () {
            return '7';
        };
        var shipmentNumber = function () {
            return '8';
        };
        var customerNumber = function () {
            return '9';
        };
        return {
            PurchaseOrder: purchaseOrder,
            CustomerOrder: customerOrder,
            DistributionOrder: distributionOrder,
            ShipmentNumber: shipmentNumber,
            CustomerNumber: customerNumber,
        };
    })();

var isInternal = function () {
    return $('#IsInternal').val();
};

var isTransporter = function () {
    return $('#IsTransporter').val();
};

var TimeBookingPage = function () {
    var reservationTableDefinition = [
        {
            classes: 'js-LoadUnload',
            displayName: 'Last/Loss',
            value: function (row) {
                if (row.IsLoading == true) {
                    return '<span class="icon icon--load-booking-table"></span>';
                } else {
                    return '<span class="icon icon--unload-booking-table"></span>';
                }
            },
            tablesawPriority: '1',
        },
        {
            classes: 'js-ReservationDate',
            displayName: 'Reservationsdatum',
            value: function (row) {
                return row['ReservationDate'];
            },
            tablesawPriority: '1',
        },
        {
            classes: 'js-From',
            displayName: 'Från',
            value: function (row) {
                return row['From'];
            },
            tablesawPriority: '1',
        },
        {
            classes: 'To',
            displayName: 'Till',
            value: function (row) {
                return row['To'];
            },
            tablesawPriority: '1',
        },
        {
            classes: 'ResourceGroupName',
            displayName: 'Anläggning',
            value: function (row) {
                return row['ResourceGroupName'];
            },
            tablesawPriority: '1',
        },
        {
            classes: 'edit-col',
            displayName: 'Redigera',
            value: function (row) {
                return row['Editable']
                    ? '<a href="javascript:void(0)" class="lm__inline-edit-button-table"></a>'
                    : '';
            },
        },
        {
            classes: 'delete-col',
            displayName: 'Ta bort',
            value: function (row) {
                return row['Editable']
                    ? '<a href="javascript:void(0)" class="lm__inline-delete-button-table"></a>'
                    : '';
            },
        },
        {
            classes: 'hidden js-ReservationId',
            displayName: 'ReservationId',
            headerClasses: 'hidden',
            value: function (row) {
                return row['ReservationId'];
            },
        },
        {
            classes: 'hidden js-DeliveryNo',
            displayName: 'DeliveryNo',
            headerClasses: 'hidden',
            value: function (row) {
                return row['DeliveryNo'];
            },
        },
        {
            classes: 'hidden js-Owner',
            displayName: 'Owner',
            headerClasses: 'hidden',
            value: function (row) {
                return row['Owner'];
            },
        },
        {
            classes: 'hidden js-CustomerNo',
            displayName: 'CustomerNo',
            headerClasses: 'hidden',
            value: function (row) {
                return row['CustomerNo'];
            },
        },
        {
            classes: 'hidden js-CustomerName',
            displayName: 'CustomerName',
            headerClasses: 'hidden',
            value: function (row) {
                return row['CustomerName'];
            },
        },
        {
            classes: 'hidden js-LicensePlateNo',
            displayName: 'LicensePlateNo',
            headerClasses: 'hidden',
            value: function (row) {
                return row['LicensePlateNo'];
            },
        },
        {
            classes: 'hidden js-MobileNo',
            displayName: 'MobileNo',
            headerClasses: 'hidden',
            value: function (row) {
                return row['MobileNo'];
            },
        },
        {
            classes: 'hidden js-Note',
            displayName: 'Note',
            headerClasses: 'hidden',
            value: function (row) {
                return row['Note'];
            },
        },
        {
            classes: 'hidden js-Email',
            displayName: 'Email',
            headerClasses: 'hidden',
            value: function (row) {
                return row['Email'];
            },
        },
        {
            classes: 'hidden js-ReminderInMinutesBefore',
            displayName: 'ReminderInMinutesBefore',
            headerClasses: 'hidden',
            value: function (row) {
                return row['ReminderInMinutesBefore'];
            },
        },
    ];

    var availableSlotsDefinition = [
        {
            classes: 'FromDateTime' + 'ToDateTime',
            displayName: 'Välj tid',
            value: function (row) {
                var isBooked = row['IsBooked'];
                var checkbox =
                    '<div class="lm__checkbox lm__tick">' +
                    '<input type="checkbox" class="bookingRows"' +
                    (isBooked ? 'disabled="disabled" checked="checked"' : '') +
                    '/>' +
                    '<label></label>' +
                    '</div>';
                return checkbox + row['FromDateTime'] + '-' + row['ToDateTime'];
            },
            tablesawPriority: '1',
            showForExternal: true,
        },
        {
            classes: 'js-LicensePlateNo',
            displayName: 'RegNr',
            value: function (row) {
                return row['LicensePlateNo'];
            },
            tablesawPriority: '1',
            showForExternal: true,
        },
        {
            classes: 'CustomerName',
            displayName: 'Kund',
            value: function (row) {
                return row['CustomerName'];
            },
            tablesawPriority: '1',
            showForExternal: true,
        },
        {
            classes: 'KontraktArtikel',
            displayName: 'Artikel',
            value: function (row) {
                return row['KontraktArtikel'];
            },
            tablesawPriority: '1',
            showForExternal: true,
        },
        {
            classes: 'Qty',
            displayName: 'Kvant',
            value: function (row) {
                return row['Qty'];
            },
            tablesawPriority: '1',
            showForExternal: true,
        },
        {
            classes: 'Unit',
            displayName: 'Enhet',
            value: function (row) {
                return row['Unit'];
            },
            tablesawPriority: '1',
            showForExternal: true,
        },
        {
            classes: 'Owner',
            displayName: 'Speditör',
            value: function (row) {
                return row['Owner'];
            },
            tablesawPriority: '1',
            showForExternal: false,
        },
        {
            classes: 'edit-col',
            displayName: 'Redigera',
            value: function (row) {
                return row['UserCanChange']
                    ? '<a href="javascript:void(0)" class="lm__inline-edit-button-table"></a>'
                    : '';
            },
            showForExternal: true,
        },
        {
            classes: 'delete-col',
            displayName: 'Ta bort',
            value: function (row) {
                return row['UserCanChange']
                    ? '<a href="javascript:void(0)" class="lm__inline-delete-button-table"></a>'
                    : '';
            },
            showForExternal: true,
        },
        {
            classes: 'hidden js-ReservationId',
            displayName: 'ReservationId',
            headerClasses: 'hidden',
            value: function (row) {
                return row['ReservationId'];
            },
            showForExternal: true,
        },
        {
            classes: 'hidden js-DeliveryNo',
            displayName: 'Leveransforsakransnr',
            headerClasses: 'hidden',
            value: function (row) {
                return row['Leveransforsakransnr'];
            },
            showForExternal: true,
        },
        {
            classes: 'hidden js-Owner',
            displayName: 'Owner',
            headerClasses: 'hidden',
            value: function (row) {
                return row['Owner'];
            },
            showForExternal: true,
        },
        {
            classes: 'hidden js-From',
            displayName: 'Från',
            headerClasses: 'hidden',
            value: function (row) {
                return row['FromDateTime'];
            },
            tablesawPriority: '1',
            showForExternal: true,
        },
        {
            classes: 'hidden js-ReservationDate',
            displayName: 'Reservationsdatum',
            headerClasses: 'hidden',
            value: function (row) {
                return row['FromDate'];
            },
            tablesawPriority: '1',
            showForExternal: true,
        },
        {
            classes: 'hidden js-CustomerNo',
            displayName: 'CustomerNo',
            headerClasses: 'hidden',
            value: function (row) {
                return row['CustomerNo'];
            },
            showForExternal: true,
        },
        {
            classes: 'hidden js-CustomerName',
            displayName: 'CustomerName',
            headerClasses: 'hidden',
            value: function (row) {
                return row['CustomerName'];
            },
            showForExternal: true,
        },
        {
            classes: 'hidden js-Note',
            displayName: 'Note',
            headerClasses: 'hidden',
            value: function (row) {
                return row['Note'];
            },
            showForExternal: true,
        },
        {
            classes: 'hidden js-MobileNo',
            displayName: 'MobileNo',
            headerClasses: 'hidden',
            value: function (row) {
                return row['MobileNo'];
            },
            showForExternal: true,
        },
        {
            classes: 'hidden js-Email',
            displayName: 'EmailAdress',
            headerClasses: 'hidden',
            value: function (row) {
                return row['EmailAdress'];
            },
            showForExternal: true,
        },
        {
            classes: 'hidden js-ReminderInMinutesBefore',
            displayName: 'ReminderInMinutesBefore',
            headerClasses: 'hidden',
            value: function (row) {
                return row['ReminderMinutesBefore'];
            },
            showForExternal: true,
        },
        {
            classes: 'hidden js-ResourceId',
            displayName: 'ResourceId',
            headerClasses: 'hidden',
            value: function (row) {
                return row['ResourceId'];
            },
            showForExternal: true,
        },
    ];

    var dialogType = GroCommon.modalInfoClass;

    var clearResultTable = function () {
        $('#resultTable').html('');
    };

    var extractForDropdown = function (elId, extractFrom) {
        var $dropdown = $('#' + elId),
            arr = [],
            extractFormLen = extractFrom.length;

        if (extractFormLen === 0) {
            var name = $dropdown.closest('div').siblings('span').text();
            name = name.replace('*', '');
            $dropdown.find(' > ul > li ').remove();
            $dropdown.attr('data-value', '');
            $dropdown.closest('div').addClass('disabled');
            $dropdown.find('> a').html(name + ' saknas');
            $('#allowedReservations').html('0');
            UpdateAllowedReservations();
        } else {
            $dropdown.closest('div').removeClass('disabled');
            for (var i = 0; i < extractFormLen; i++) {
                arr[arr.length] =
                    '<li data-value="' +
                    extractFrom[i].Value +
                    '"><a href="javascript:void(0)">' +
                    extractFrom[i].Display +
                    '</a></li>';
                if (elId === 'resourceDrp') {
                    $dropdown.attr('regNoMandatory', extractFrom[i].RegNoMandatory);
                    $dropdown.attr('allowedreservations', extractFrom[i].AllowedReservations);
                }
                if (extractFrom[i].IsSelected == true) {
                    $dropdown.find('> a').html(extractFrom[i].Display);
                    $dropdown.attr('data-value', extractFrom[i].Value);
                }
            }
        }
        return arr.join('');
    };

    var initDeleteClickEvent = function ($table) {
        $table.find('.lm__inline-delete-button-table').on('click', function () {
            var row = $(event.currentTarget).closest('tr');
            var reservationId = $(row).find('.js-ReservationId').html();
            var reservationDate = $(row).find('.js-ReservationDate').html();
            var from = $(row).find('.js-From').html();
            var owner = $(row).find('.js-Owner').html();
            var customerNo = $(row).find('.js-CustomerNo').html();
            deleteReservation(reservationId, from, owner, reservationDate);
        });
    };

    var initEditClickEvent = function ($table) {
        $table.find('.lm__inline-edit-button-table').on('click', function (event) {
            var row = $(event.currentTarget).closest('tr');
            var editReservationData = {
                deliveryNo: $(row).find('.js-DeliveryNo').html(),
                reservationId: $(row).find('.js-ReservationId').html(),
                emailAddress: $(row).find('.js-Email').html(),
                licensePlateNo: $(row).find('.js-LicensePlateNo').html(),
                mobileNo: $(row).find('.js-MobileNo').html(),
                note: $(row).find('.js-Note').html(),
                reminderInMinutesBefore: $(row).find('.js-ReminderInMinutesBefore').html(),
                owner: $(row).find('.js-Owner').html(),
                reservationDate: $(row).find('.js-ReservationDate').html(),
                from: $(row).find('.js-From').html(),
                customerNo: $(row).find('.js-CustomerNo').html(),
                customerName: $(row).find('.js-CustomerName').html(),
            };

            editReservation(editReservationData);
        });
    };

    var showShipmentAlreadyBookedOrDelivered = function (message) {
        var alreadyText = message;
        $('#js-already-delivered').html(alreadyText);
        $('#js-already-delivered').show();
        initDeleteClickEvent($('.lm__reservation-table'));
        initEditClickEvent($('.lm__reservation-table'));
    };

    var hideShipmentAlreadyBookedOrDelivered = function () {
        $('#js-already-delivered').html();
        $('#js-already-delivered').hide();
    };

    var hideSelectionOptions = function () {
        $('.js-hide-show-selection-options').hide();
        $('#SaveTable').hide();
        $('#saveBtn').hide();
        $('#resultTable-box').hide();
    };

    var showSelectionOptions = function () {
        $('.js-hide-show-selection-options').show();
    };

    var showCompanySelectors = function () {
        $('.companySelectors').show();
    };

    var hideCompanySelectors = function () {
        $('.companySelectors').hide();
    };

    var getBookingReference = function () {
        return $('#searchFieldTxt').val();
    };

    var getCurrentlySelectedReferenceType = function () {
        return $('#search-option').attr('data-value');
    };

    var getAllowedReservationsForSelectedresourceGroup = function () {
        return $('#resourceDrp').attr('allowedreservations');
    };

    var showAllowedReservationsInfo = function () {
        $('#allowedReservationsInfo').show();
    };

    var hideAllowedReservationsInfo = function () {
        $('#allowedReservationsInfo').hide();
    };

    var showReservationStops = function () {
        $('#showReservationStops').show();
    };

    var hideReservationStops = function () {
        $('#showReservationStops').hide();
    };

    var hideDriedOrUndried = function () {
        $('#agreementDriedUnDried').hide();
    };

    var getSelectedArticle = function () {
        return $('#articlesDrp').attr('data-value');
    };

    var getSelectedResourceGroupId = function () {
        return $('#resourceDrp').attr('data-value');
    };

    var getLoadOrUnload = function () {
        return $("input[name='loadOrUnloadRad']:checked").val();
    };

    var getCompanySelected = function () {
        return $("input[name='companySelected']:checked").val();
    };

    var getIgnoreSort = function () {
        return $('#IgnoreSort').val();
    };

    var setIgnoreSort = function (ignoreSort) {
        $('#IgnoreSort').val(ignoreSort);
    };

    var getBackupArticle = function () {
        return $('#BackupArticle').val();
    };

    var setBackupArticle = function (backupArticle) {
        $('#BackupArticle').val(backupArticle);
    };

    var getRequestToken = function () {
        return $('input[name=__RequestVerificationToken]').val();
    };

    var getDesiredReservations = function () {
        var rowIsNewBooking = function (row) {
            var rowIsChecked = !!$(row).has(':checkbox:checked').length;
            var rowIsReserved = !!$(row).find('.js-ReservationId').html();
            return rowIsChecked && !rowIsReserved;
        };

        return $('#availableSlotTable tr').filter(function () {
            return rowIsNewBooking(this);
        });
    };

    var setReferenceTypeToCurrentlySelected = function () {
        $('#latest-searched-reference-type').data(
            'referenceType',
            getCurrentlySelectedReferenceType()
        );
    };
    var getReferenceType = function () {
        return $('#latest-searched-reference-type').data('referenceType');
    };

    var clearStartFields = function () {
        $('#IDLevnr_StartValue').val('');
        $('#IDEpost_StartValue').val('');
        $('#IDMobil_StartValue').val('');
    };

    var searchCustomer = function (isPostMakeBooking, changeRadioType) {
        if (!!isPostMakeBooking) {
            clearResultTable();
            clearBookingInformation();
            clearStartFields();
            clearForm();
        }

        hideShipmentAlreadyBookedOrDelivered();
        hideDriedOrUndried();
        showCompanySelectors();

        var bookingReference = getBookingReference();
        var resourceGroup = getSelectedResourceGroupId();

        if ($.trim(bookingReference) != '') {
            setReferenceTypeToCurrentlySelected();
            var referenceType = getReferenceType();
            var loadOrUnloadValue = getLoadOrUnload();
            var customerSearchType = getCompanySelected();
            var token = getRequestToken();
            TimeBookingFunction.blockUI();
            var parameters = {
                resourceGroupId: resourceGroup,
                searchString: bookingReference,
                searchType: referenceType,
                loadOrUnloadValue: loadOrUnloadValue,
                customerSearchType: customerSearchType,
                __RequestVerificationToken: token,
            };
            $.ajax({
                type: 'POST',
                url: '/api/time-booking/CustomerSearch',
                dataType: 'json',
                data: parameters,

                success: function (response) {
                    TimeBookingFunction.unBlockUI();

                    if (!!isPostMakeBooking) {
                        resetSelectedDate();
                    }

                    searchCustomerSuccess(
                        response.customerResult,
                        isPostMakeBooking,
                        changeRadioType
                    );
                },
                error: function (response) {
                    TimeBookingFunction.unBlockUI();
                },
            });
        }

        var searchCustomerSuccess = function (responseResult, isPostMakeBooking, changeRadioType) {
            var customerNotFound = function () {
                return (
                    responseResult.Customers == null ||
                    (responseResult.Customers.length < 1 &&
                        getReferenceType() == ReferenceType.CustomerNumber())
                );
            };

            //--- Transfer searchText to lower part of page.
            $('#IDLevnr_StartValue').val($('#searchFieldTxt').val());
            $('#IDLevnr').val($('#searchFieldTxt').val());

            //--- This event should only fire when the radios is not the origin of the call
            if (!changeRadioType) {
                if (!isPostMakeBooking) {
                    if (responseResult.Reservations.length > 0) {
                        // Set Load/Unload based on order.
                        responseResult.Reservations.forEach(updateRadioButtonsAfterSearch);
                    } else {
                        setupLoadUnloadRadios(getReferenceType(), null);
                    }
                } else {
                    setupLoadUnloadRadios(getReferenceType(), null);
                }
            }

            var dialogHtml;
            if (!responseResult) {
                TimeBookingFunction.clearContentToModal('#dialogArea');
                dialogHtml = '<br/>Inget resultat kunde hämtas<br/>';
                TimeBookingFunction.fillContentToModal(
                    '#dialogArea',
                    'Fel uppstod',
                    dialogHtml,
                    true,
                    dialogType.error
                );
                return;
            }

            if (
                responseResult.BookingStatus == BookingStatus.NotFound() &&
                (getReferenceType() != ReferenceType.CustomerNumber() || customerNotFound())
            ) {
                TimeBookingFunction.clearContentToModal('#dialogArea');
                TimeBookingFunction.fillContentToModal(
                    '#dialogArea',
                    'Referens kunde ej hittas.',
                    'Kunde ej hitta referens med nummer: ' + getBookingReference() + '.',
                    true,
                    dialogType.info
                );
                return;
            }

            if (responseResult.Status == 500) {
                TimeBookingFunction.clearContentToModal('#dialogArea');
                dialogHtml = responseResult.ErrorMessage + '<br/><br/>';
                TimeBookingFunction.fillContentToModal(
                    '#dialogArea',
                    'Fel uppstod',
                    dialogHtml,
                    true,
                    dialogType.error
                );
                return;
            }

            if (responseResult.BookingStatus == BookingStatus.Delivered()) {
                showShipmentAlreadyBookedOrDelivered(
                    '<strong>Leverans är redan genomförd.</strong><br/> Leverans av <strong>' +
                        getBookingReference() +
                        '</strong> är redan genomförd.'
                );
            } else if (responseResult.Reservations.length > 0) {
                var toggleColumns = true;
                var id = 'existingBookingsTable';
                var tableClasses = 'lm__reservation-table';
                var table = gro.modules.tableBuilder.create(
                    id,
                    tableClasses,
                    responseResult.Reservations,
                    reservationTableDefinition,
                    toggleColumns
                );
                var bookingTitle = responseResult.Reservations.length > 1 ? 'Bokningar' : 'Bokning';
                var text =
                    '<strong>' + bookingTitle + ' för ' + getBookingReference() + '</strong><br/>';
                text += 'Redigera/ta bort i listan nedan.';
                text += '<p class="u1/1-mobile u-hide-tablet">Välj kolumner som skall visas</p>';

                var reservations = responseResult.Reservations[0];

                if (
                    typeof reservations !== 'undefined' &&
                    reservations.LicensePlateNo != '' &&
                    getReferenceType() === ReferenceType.ShipmentNumber()
                ) {
                    $('#IDReg').val(reservations.LicensePlateNo);
                }

                showShipmentAlreadyBookedOrDelivered(text + table);
                $('#js-already-delivered').trigger('enhance.tablesaw');
                if (responseResult.BookingStatus == BookingStatus.ReservationExists()) {
                    hideSelectionOptions();
                }
            } else {
                hideShipmentAlreadyBookedOrDelivered();
            }

            if (responseResult.Customers && getReferenceType() === ReferenceType.CustomerNumber()) {
                showCompanySelectors();
            } else {
                hideCompanySelectors();
            }

            var customers =
                typeof responseResult.Customers == 'string'
                    ? JSON.parse(responseResult.Customers)
                    : responseResult.Customers;
            setCustomerInfo(customers, responseResult.BookingOrder);

            if (
                getCurrentlySelectedReferenceType() === ReferenceType.CustomerNumber() &&
                responseResult.Ios &&
                responseResult.Ios.length > 0 &&
                isTransporter() != 'True' &&
                isInternal() != 'True'
            ) {
                hideSelectionOptions();
                var customerNo =
                    responseResult.Customers && responseResult.Customers.length > 0
                        ? responseResult.Customers[0].CustomerNo
                        : '';
                TimeBookingFunction.clearContentToModal('#dialogArea');

                dialogHtml = gro.modules.timeBookingPage.listIoNumbers(
                    customerNo,
                    responseResult.Ios
                );

                TimeBookingFunction.fillContentToModal(
                    '#dialogArea',
                    'Välj inköpsorder nedan',
                    dialogHtml,
                    true
                );
            } else {
                if (responseResult.BookingStatus === BookingStatus.Delivered()) {
                    hideSelectionOptions();
                } else {
                    showSelectionOptions();
                }
            }

            if (
                responseResult.BookingOrder !== null &&
                !(ReferenceType.CustomerNumber() == getReferenceType()) &&
                !isPostMakeBooking
            ) {
                if (
                    responseResult.BookingOrder.Quantity != undefined &&
                    responseResult.BookingOrder.Quantity !== null
                ) {
                    $('#quantityTxt').val(responseResult.BookingOrder.Quantity / 1000);
                }

                if (responseResult.BookingOrder.DeliveryDate !== null) {
                    var newDate = new Date(
                        responseResult.BookingOrder.DeliveryDate);
                    var now = new Date();
                    if (newDate > now) {
                        $('#selectedDate').val(newDate.toShortDateString());
                    } else {
                        $('#selectedDate').val(now.toShortDateString());
                    }
                    if ($('#selectedDate').val().length < 10) {
                        $('#selectedDate').val(now.toShortDateString());
                    }
                }

                if (getReferenceType() === ReferenceType.PurchaseOrder()) {
                    if (responseResult.BookingOrder.Status >= 40) {
                        TimeBookingFunction.unBlockUI();
                    } else if (
                        responseResult.BookingOrder.ItemNumber &&
                        responseResult.BookingOrder.DeliveryAssuranceConfirmed == false
                    ) {
                        TimeBookingFunction.clearContentToModal('#dialogArea');
                        TimeBookingFunction.fillContentToModal(
                            '#dialogArea',
                            'Obs!',
                            'Bokning ej tillåten på denna inköpsorder! Leveransförsäkran saknas',
                            true,
                            dialogType.error
                        ); //"Redan bokad",
                    }

                    //--- if internal : set PO warehouse as selected but show all articles and all warehouses,
                    //    else only load the ones related to the PO
                    if (isInternal === 'True') {
                        $('#resourceDrp').attr('data-value', responseResult.BookingOrder.Warehouse);
                        getResourceGroups('', 'all');
                    } else {
                        getResourceGroups(responseResult.BookingOrder.Warehouse);
                    }
                    searchVehiclesAndItemsByResourceGroup('', getSelectedResourceGroupId());
                } else if (
                    (getReferenceType() === ReferenceType.CustomerOrder() ||
                        getReferenceType() === ReferenceType.DistributionOrder() ||
                        getReferenceType() === ReferenceType.ShipmentNumber()) &&
                    document.getElementById('resourceDrp').innerText != 'Anläggning saknas'
                ) {
                    //--- if internal : set PO warehouse as selected but show all articles and all warehouses,
                    //    else only load the ones related to the PO
                    if (isInternal === 'True') {
                        $('#resourceDrp').attr('data-value', responseResult.BookingOrder.Warehouse);
                        getResourceGroups('', 'all');
                    } else {
                        getResourceGroups(responseResult.BookingOrder.Warehouse);
                    }

                    searchVehiclesAndItemsByResourceGroup('', getSelectedResourceGroupId());
                } else if (
                    (getReferenceType() === ReferenceType.CustomerOrder() ||
                        getReferenceType() === ReferenceType.DistributionOrder() ||
                        getReferenceType() === ReferenceType.ShipmentNumber()) &&
                    document.getElementById('resourceDrp').innerText == 'Anläggning saknas'
                ) {
                    //--- if internal : set PO warehouse as selected but show all articles and all warehouses,
                    //    else only load the ones related to the PO
                    if (isInternal === 'True') {
                        $('#resourceDrp').attr('data-value', responseResult.BookingOrder.Warehouse);
                        getResourceGroups('', 'all');
                    } else {
                        getResourceGroups(responseResult.BookingOrder.Warehouse);
                    }

                    searchVehiclesAndItemsByResourceGroup('', getSelectedResourceGroupId());
                }

                if (
                    responseResult.BookingOrder.ItemNumber !== null &&
                    responseResult.BookingOrder.ItemNumber != ''
                ) {
                    var dried = 'torkad';
                    var $articlesDrp = $('#articlesDrp');
                    $('#agreementDriedUnDried').val(
                        responseResult.BookingOrder.Torkat ? 'Torkad' : 'Otorkad'
                    );
                    var driedUnDried = $('#agreementDriedUnDried').val();

                    if (!responseResult.BookingOrder.Torkat) {
                        dried = 'otorkad';
                    }

                    var searchString = new String(
                        responseResult.BookingOrder.ItemNumber +
                            '-' +
                            dried +
                            '-' +
                            responseResult.BookingOrder.Sort
                    );

                    searchString = searchString.toLowerCase();
                    $('#articlesDrp > ul li').each(function () {
                        if ($(this).attr('data-value').toLowerCase().indexOf(searchString) != -1) {
                            $articlesDrp.attr('data-value', $(this).attr('data-value'));
                            $articlesDrp.find('>a').html($(this).find('>a').html());
                        }
                    });
                }

                $('div').data('Linenumber', responseResult.BookingOrder.Linenumber);
                $('#Linenumber').val(responseResult.BookingOrder.Linenumber);
            } else if (
                getReferenceType() === ReferenceType.CustomerNumber() &&
                !isPostMakeBooking
            ) {
                var company = $("input[name = 'companySelected']:checked").attr('value');
                getResourceGroups('', company);
            }
            if (getCurrentlySelectedReferenceType() === ReferenceType.CustomerNumber()) {
                $('#IDReg').val('');
                $('#IDReg_StartValue').val('');
            } else {
                if (responseResult.RegNo !== null && responseResult.RegNo != '') {
                    $('#IDReg').val(responseResult.RegNo);
                }
            }
            if (validateRequiredFieldsForSearch()) {
                $('#searchAvailableSlotsBtn').parent().removeClass('disabled-btn');
                searchAvailableSlots();

                var shouldCopyReferenceTypes = [
                    ReferenceType.PurchaseOrder(),
                    ReferenceType.DistributionOrder(),
                    ReferenceType.ShipmentNumber(),
                ];
                if (shouldCopyReferenceTypes.indexOf(getReferenceType()) !== -1) {
                    $('#IDLevnr_StartValue').val(getBookingReference());
                } else {
                    $('#IDLevnr_StartValue').val('');
                }
            } else {
                $('#searchAvailableSlotsBtn').parent().addClass('disabled-btn');
            }
        };

        var setCustomerInfo = function (customers, bookingOrder) {
            if (customers != null) {
                var noOfCustomers = customers.length;
                if (noOfCustomers == 1) {
                    $('#searchCustomerNo').text(customers[0].CustomerNo);
                    $('#searchCustomerName').text(customers[0].Name);
                    $('#customerNo').val(customers[0].CustomerNo);
                    $('#customerName').val(customers[0].Name);
                    $('#IDEpost_StartValue').val(customers[0].Email);
                    $('#IDMobil_StartValue').val(customers[0].MobileNo);

                    $('#IDEpost').val(customers[0].Email);
                    $('#IDMobil').val(customers[0].MobileNo);
                    displayWarningAboutDemoCustomer(customers[0].Name);
                } else if (bookingOrder != null) {
                    TimeBookingFunction.clearContentToModal('#dialogArea');
                    TimeBookingFunction.fillContentToModal(
                        '#dialogArea',
                        'Information saknas',
                        'Hittade ingen kund, avtal, transportorder eller sändningsorder med nr ' +
                            getBookingReference() +
                            '.',
                        true,
                        dialogType.info
                    );
                }
            }
        };

        var displayWarningAboutDemoCustomer = function (customerName) {
            customerName = customerName ? customerName.toLowerCase() : "";
            if (customerName.indexOf('testkund') >= 0 || customerName.indexOf('demokund') >= 0) {
                TimeBookingFunction.clearContentToModal('#dialogArea');
                TimeBookingFunction.fillContentToModal(
                    '#dialogArea',
                    'Demokund',
                    'Obs! Du försöker boka på en test eller demokund vilket orsakar problem i vissa fall. Gör därför alltid bokningen i rätt kundnummer!',
                    true,
                    dialogType.error
                );
            }
        };
    };

    var resetFieldsAfterDelete = function () {
        var reminder = $('#IDReminder');
        reminder.attr('data-value', '0');
        reminder.find('>a').html('Ingen påminnelse');
        reminder.find('input[name="IDReminder"]').val('0');
        $('#IDOvrigt').val('');
        $('#IDLevnr').val($('#IDLevnr_StartValue').val());
        $('#IDEpost').val($('#IDEpost_StartValue').val());
        $('#IDMobil').val($('#IDMobil_StartValue').val());
        $('#saveAction').val('New');
        $('#updateBtn').hide();
        $('#saveBtn').show();
    };

    var clearBodyInformation = function () {
        var reminder = $('#IDReminder');
        reminder.attr('data-value', '0');
        reminder.find('>a').html('Ingen påminnelse');
        reminder.find('input[name="IDReminder"]').val('0');
        $('#IDOvrigt').val('');
        $('#IDLevnr').val($('#IDLevnr_StartValue').val());
        $('#IDEpost').val($('#IDEpost_StartValue').val());
        $('#IDMobil').val($('#IDMobil_StartValue').val());
        $('#saveAction').val('New');
        $('#updateBtn').hide();
        $('#saveBtn').show();

        $('#myDisplayMessage').html('');
        $('#displayMessageHeader').html('&nbsp;');
        $('#newCustomerNo').attr('disabled', 'disabled');
    };

    var clearForm = function () {
        var reminder = $('#IDReminder');
        reminder.attr('data-value', '0');
        reminder.find('>a').html('Ingen påminnelse');
        reminder.find('input[name="IDReminder"]').val('0');
        $('#IDOvrigt').val('');
        $('#IDLevnr_StartValue').val('');
        $('#IDLevnr').val('');
        $('#IDReg').val('');
        $('#IDEpost').val($('#IDEpost_StartValue').val());
        $('#IDMobil').val($('#IDMobil_StartValue').val());
        $('#saveAction').val('New');
        $('#updateBtn').hide();
        $('#saveBtn').show();

        $('#myDisplayMessage').html('');
        $('#displayMessageHeader').html('&nbsp;');
        $('#newCustomerNo').attr('disabled', 'disabled');
    };

    var updateReservation = function () {
        var updateReservationSuccess = function (response) {
            var content = $('<p></p>');
            for (var i = 0; i < response.length; i++) {
                if (response[i].Status == 200) {
                    content.append(response[i].Message);
                } else {
                    content.append(response[i].ErrorMessage);
                }
                content.append('<br />');
            }
            TimeBookingFunction.clearContentToModal('#dialogArea');
            clearFm();
            clearBodyInformation();
            TimeBookingFunction.fillContentToModal(
                '#dialogArea',
                'Bokningen uppdaterad',
                content,
                true,
                dialogType.success
            );
            searchAvailableSlots();
        };

        var updateReservationError = function () {
            TimeBookingFunction.clearContentToModal('#dialogArea');
            TimeBookingFunction.fillContentToModal(
                '#dialogArea',
                'Uppdateringsfel',
                'Fel uppstod när bokningen skulle uppdateras.',
                true,
                dialogType.error
            );
            searchAvailableSlots();
        };

        var errors = validateFieldsForReservation(true);

        if (errors.length > 0) {
            TimeBookingFunction.clearContentToModal('#dialogArea');
            var errorContent = $('<p></p>').append('<ul>' + errors.join('') + '</ul>');
            TimeBookingFunction.fillContentToModal(
                '#dialogArea',
                'Uppgifter saknas',
                errorContent,
                true,
                dialogType.success
            );
        } else {
            var email = $('#IDEpost').val();
            var mobileNo = $('#IDMobil').val();
            var licensePlateNo = $('#IDReg').val();
            var leveransforsakransnummer = $('#IDLevnr').val();

            if (
                TimeBookingFunction.validateSaveTable(
                    email,
                    mobileNo,
                    licensePlateNo,
                    leveransforsakransnummer
                )
            ) {
                var form = $('#form-time-booking');
                $.ajax({
                    type: 'POST',
                    url: '/api/time-booking/UpdateReservation',
                    data: form.serialize(),
                    success: function (response) {
                        updateReservationSuccess(response.updateReservations);
                    },
                    error: function (response) {
                        updateReservationError(response.updateReservations);
                    },
                });
            }
        }
    };

    var updateReservationInformation = function (editReservationData) {
        $.ajax({
            type: 'POST',
            url: '/api/time-booking/UpdateReservationInformation',
            data: editReservationData,
            success: function (response) {
                TimeBookingFunction.unBlockUI();

                searchCustomer();
            },
            error: function (response) {
                TimeBookingFunction.unBlockUI();
                alert('error');
            },
        });
    };

    var deleteReservation = function (reservationId, time, owner, dateRegistered) {
        var deleteReservationSuccess = function (response) {
            var content = $('<p></p>');
            for (var i = 0; i < response.length; i++) {
                if (response[i].Status == 500) {
                    content.append(
                        '<span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 20px 0;"></span>'
                    );
                }
                content.append(response[i].Message + '<br />');
            }

            TimeBookingFunction.clearContentToModal('#dialogArea');
            TimeBookingFunction.fillContentToModal(
                '#dialogArea',
                'Borttagning',
                content,
                true,
                dialogType.error
            );

            $('#dialogArea')
                .find('.btn-ok')
                .on('click', function () {
                    searchCustomer();
                });

            if (getReferenceType() !== ReferenceType.CustomerNumber()) {
                clearDropDown('resourceDrp', 'Välj anläggning');
                $('input[name="loadOrUnloadRad"]').prop('checked', false);
            }
            searchCustomer();
        };

        var deletReservationError = function (response) {
            TimeBookingFunction.clearContentToModal('#dialogArea');
            TimeBookingFunction.fillContentToModal(
                '#dialogArea',
                'Raderingsfel',
                'Fel uppstod när bokningen skulle raderas.',
                true,
                dialogType.error
            );
            searchAvailableSlots();
        };

        var deleteReservationProcess = function (reservationId, owner, dateRegistered) {
            //clearBodyInformation();
            var o = {};
            o.reservationId = reservationId;
            o.owner = owner;
            o.dateRegistered = dateRegistered;
            $.ajax({
                type: 'POST',
                url: '/api/time-booking/DeleteReservation',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(o),

                success: function (response) {
                    deleteReservationSuccess(response.deleteReservations);
                },
                error: function (response) {
                    deletReservationError(response.deleteReservations);
                },
            });
        };

        var content = $('<p></p>').append(
            'Vill du verkligen radera bokningen<br /> kl: ' + time + '?'
        );
        TimeBookingFunction.clearContentToDeleteDialog();
        TimeBookingFunction.fillContentToDeleteDialog('Ta bort bokning?', content);
        $('#deleteDialog')
            .find('.btn-ok')
            .on('click', function () {
                deleteReservationProcess(reservationId, owner, dateRegistered);
            });
    };

    var editReservation = function (editReservationData) {
        var modalContent = gro.modules.timeBookingPage.editForm(editReservationData);
        TimeBookingFunction.clearContentToModal('#dialogArea');
        TimeBookingFunction.fillContentToModal(
            '#dialogArea',
            'Redigera bokning',
            modalContent,
            true,
            null
        );
        $('#dialogArea')
            .find('#edit-form-button-save')
            .on('click', function () {
                editReservationData.licensePlateNo = $('#license-plate-input').val();
                editReservationData.emailAddress = $('#email-address-input').val();
                editReservationData.mobileNo = $('#mobile-no-input').val();
                editReservationData.note = $('#note-input').val();
                editReservationData.reminderInMinutesBefore = $(
                    '#reminder-combobox option:selected'
                ).val();
                $('#dialogArea').addClass('hidden');
                TimeBookingFunction.blockUI();

                updateReservationInformation(editReservationData);
            });
    };

    var searchVehiclesAndItemsByResourceGroup = function (
        currentArticleItem,
        resource,
        showAllArticles
    ) {
        var selectedVehicleId = $('#vehicleTypeDrp').attr('data-value');
        var selectedVehicleName = $('#vehicleTypeDrp')
            .find('*[data-value="' + selectedVehicleId + '"] > a')
            .text();
        var selectedArticle = $('#articlesDrp').attr('data-value');

        var searchItemComplete = function (response) {
            var vehicles =
                typeof response.Vehicles == 'string'
                    ? JSON.parse(response.Vehicles)
                    : response.Vehicles;
            var reservationStops =
                typeof response.ReservationStops == 'string'
                    ? JSON.parse(response.ReservationStops)
                    : response.ReservationStops;
            var articles =
                typeof response.Items == 'string' ? JSON.parse(response.Items) : response.Items;
            setIgnoreSort(response.IgnoreSort);

            clearDropDown('articlesDrp', 'Välj artikel');
            $('#articlesDrp > ul').append(extractForDropdown('articlesDrp', articles));
            setDropdown($('#articlesDrp').parent(), 'type3');
            var indexOfSelectedArticle = articles.findIndex(function (v) {
                return v.Value === selectedArticle;
            });
            if (indexOfSelectedArticle > -1) {
                $('#articlesDrp > a').html(articles[indexOfSelectedArticle].Display);
                $('#articlesDrp').attr('data-value', articles[indexOfSelectedArticle].Value);
            } else if (articles.length > 0) {
                $('#vehicleTypeDrp > a').html(articles[0].Display);
                $('#vehicleTypeDrp').attr('data-value', articles[0].Value);
            }

            var articleValue = $('#articlesDrp').attr('data-value');
            if (articleValue !== null && articleValue !== '') {
                var articleArr = articleValue.split('-');
                var driedUndried = articleArr[1];
                if (driedUndried.length >= 2) {
                    driedUndried =
                        driedUndried.substring(0, 1).toUpperCase() + driedUndried.substring(1);
                }
                $('#agreementDriedUnDried').val(driedUndried);
            }

            $('#vehicleTypeDrp > ul').append(extractForDropdown('vehicleTypeDrp', vehicles));
            setDropdown($('#vehicleTypeDrp').parent(), 'type3');
            var indexOfSelectedVehicle = vehicles.findIndex(function (v) {
                return v.Display === selectedVehicleName;
            });
            if (indexOfSelectedVehicle > -1) {
                $('#vehicleTypeDrp > a').html(vehicles[indexOfSelectedVehicle].Display);
                $('#vehicleTypeDrp').attr('data-value', vehicles[indexOfSelectedVehicle].Value);
            } else if (vehicles.length > 0) {
                $('#vehicleTypeDrp > a').html(vehicles[0].Display);
                $('#vehicleTypeDrp').attr('data-value', vehicles[0].Value);
            }

            searchItemEvent();
            validateRequiredFieldsEvent();
            buildReservationStops(reservationStops);
        };

        var buildReservationStops = function (reservationStops) {
            var i = 0;
            var arr = [];
            for (i = 0; i < reservationStops.length; i++) {
                arr[arr.length] = '<li>' + reservationStops[i].ResourceName + '</li>';
                arr[arr.length] =
                    '<li>' +
                    reservationStops[i].FromDate +
                    ' ' +
                    reservationStops[i].FromTime +
                    ' - ';
                if (reservationStops[i].ToDate.length > 0) {
                    arr[arr.length] =
                        reservationStops[i].ToDate + ' ' + reservationStops[i].ToTime + '</li>';
                } else {
                    arr[arr.length] = ' tillsvidare</li>';
                }
                arr[arr.length] =
                    '<li style="font-style: italic">' + reservationStops[i].Message + '<br /></li>';
            }
            $('#showReservationStops').find('> ul').html(arr.join(''));
            if (i > 0) {
                showReservationStops();
            } else {
                hideReservationStops();
            }
        };

        var resourceValue = resource;
        var selectedDateValue = $('#selectedDate').val();

        if (!currentArticleItem) {
            currentArticleItem = getSelectedArticle();
        }

        var showOnlyUnloadingItems = $("input:radio[name='loadOrUnloadRad']:checked").val() == '2';
        clearDropDown('articlesDrp', 'Välj artikel');
        clearDropDown('vehicleTypeDrp', 'Välj fordon');
        hideReservationStops();
        var bookingReference = getBookingReference();
        var referenceType = getReferenceType();

        if (
            (bookingReference != '' && getReferenceType() !== ReferenceType.CustomerNumber()) ||
            !showAllArticles
        ) {
            if (resourceValue != '0' && resourceValue != '' && selectedDateValue != '') {
                TimeBookingFunction.blockUI();

                var data = {
                    bookingReference: bookingReference,
                    referenceType: referenceType,
                    resourceGroupId: resourceValue,
                    selectedDate: selectedDateValue,
                    currentArticleItem: currentArticleItem,
                    showOnlyUnloadingItems: showOnlyUnloadingItems,
                };

                $.ajax({
                    type: 'POST',
                    url: '/api/time-booking/loadItemsOnResourceGroupForBookingReference',
                    data: data,
                    async: false,
                    success: function (response) {
                        TimeBookingFunction.unBlockUI();
                        searchItemComplete(response);
                    },
                    error: function (response) {
                        TimeBookingFunction.unBlockUI();
                        console.log(response);
                    },
                });
            }
        } else {
            if (resourceValue != '0' && resourceValue != '' && selectedDateValue != '') {
                TimeBookingFunction.blockUI();

                var data = {
                    resourceGroupId: resourceValue,
                    selectedDate: selectedDateValue,
                    currentArticleItem: currentArticleItem,
                    showOnlyUnloadingItems: showOnlyUnloadingItems,
                };

                $.ajax({
                    type: 'POST',
                    url: '/api/time-booking/loadItemsOnResourceGroup',
                    data: data,
                    async: false,
                    success: function (response) {
                        searchItemComplete(response);
                        TimeBookingFunction.unBlockUI();
                    },
                    error: function () {
                        TimeBookingFunction.unBlockUI();
                        alert('Error');
                    },
                });
            }
        }
    };

    var clearDropDown = function (elId, defaultText) {
        $('#' + elId + '> ul > li').remove();
        if ($.trim(defaultText) != '') {
            $('#' + elId).attr('data-value', '');
            if (elId == 'resourceDrp') {
                $('#' + elId).attr('allowedreservations', '');
                $('#' + elId).attr('regnomandatory', '');
            }
            $('#' + elId).attr('data-value', '');
            $('#' + elId + '> a').html(defaultText);
        }
    };

    var clearBookingInformation = function () {
        $('input[name="loadOrUnloadRad"]').prop('checked', false);
        clearDropDown('resourceDrp', 'Välj anläggning');
        clearDropDown('articlesDrp', 'Välj artikel');
        clearDropDown('vehicleTypeDrp', 'Välj fordon');
        clearQuantity();
        resetSelectedDate();
    };

    var clearQuantity = function () {
        $('#quantityTxt').val('0');
    };

    var resetSelectedDate = function () {
        var currentDate = new Date();
        var dateString = currentDate.toShortDateString();
        $('#selectedDate').val(dateString);
    };

    var validateRequiredFieldsForSearch = function () {
        var aRequiredFieldHasNoValue = false;
        $('.searchSlotRequired').each(function () {
            if ($(this).is('input')) {
                if ($.trim($(this).val()).length == 0) {
                    aRequiredFieldHasNoValue = true;
                    if ($(this).is('#quantityTxt')) {
                        $('#Quantity-error').hide();
                        $(this).removeClass('error');
                    }
                } else if ($(this).is('#quantityTxt')) {
                    if (!$.isNumeric($.trim($(this).val()))) {
                        aRequiredFieldHasNoValue = true;
                        $('#Quantity-error').show();
                        $(this).addClass('error');
                    } else {
                        $('#Quantity-error').hide();
                        $(this).removeClass('error');
                    }
                }
            }
            if ($(this).is('li')) {
                if ($(this).attr('data-value') == 0 || $(this).attr('data-value') == '') {
                    aRequiredFieldHasNoValue = true;
                }
            }
            if (!$('#searchCustomerNo').text()) {
                aRequiredFieldHasNoValue = true;
            }
        });
        return !aRequiredFieldHasNoValue;
    };

    var filterColumnForExternalUsers = function (columnDefinition) {
        return columnDefinition.filter(function (column) {
            return column.showForExternal;
        });
    };

    var setupResultTable = function (resultTableJson, filterForExternal) {
        clearResultTable();
        var slotsDefinition = availableSlotsDefinition;
        if (filterForExternal)
            slotsDefinition = filterColumnForExternalUsers(availableSlotsDefinition);
        $('#resultTable-box').show();
        var table = gro.modules.tableBuilder.create(
            'availableSlotTable',
            'lm__reservation_table',
            resultTableJson,
            slotsDefinition,
            true
        );
        $('#resultTable').append(table);
        initDeleteClickEvent($('#availableSlotTable'));
        initEditClickEvent($('#availableSlotTable'));
    };
    var hookupEventsForTimeCheckboxes = function () {
        UpdateAllowedReservations();
        $('.bookingRows').change(function () {
            var anyChecked = false;
            $('.bookingRows').each(function () {
                if ($(this).prop('checked')) {
                    anyChecked = true;
                }
            });
            UpdateAllowedReservations();
            if (anyChecked) {
                $('#SaveTable').show();
                $('#saveBtn').removeClass('disabled-btn');
                clearBodyInformation();
                TimeBookingFunction.clearValidateSaveTable();
            } else {
                $('#SaveTable').hide();
                $('#saveBtn').hide();
                $('#saveBtn').addClass('disabled-btn');
            }
        });
    };

    var bindCloseModalButton = function () {
        $('#dialogArea')
            .find('#js-close-modal-button')
            .on('click', function () {
                $('#dialogArea').addClass('hidden');
            });
    };

    var bindFullyBookedModalButtons = function (firstBookableDay, filterForExternal) {
        bindCloseModalButton();

        $('#dialogArea')
            .find('#js-go-to-next-date-button')
            .on('click', function () {
                $('#selectedDate').datepicker().datepicker('setDate', firstBookableDay.Date);
                searchVehiclesAndItemsByResourceGroup('', $('#resourceDrp').attr('data-value'));
                setupResultTable(firstBookableDay.TimeSlots, filterForExternal);

                hookupEventsForTimeCheckboxes();
                $('#dialogArea').addClass('hidden');
            });
    };

    function parseJsonDate(jsonDateString) {
        return new Date(jsonDateString);
    }

    Date.prototype.yyyymmdd = function () {
        var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
        var dd = this.getDate().toString();

        return [
            this.getFullYear(),
            '-',
            mm.length === 2 ? '' : '0',
            mm,
            '-',
            dd.length === 2 ? '' : '0',
            dd,
        ].join(''); // padding
    };

    var searchAvailableSlots = function () {
        var showHideTimebookingTable = function (isShow) {
            if (isShow) {
                $('#resultTable').show();
                $('#allowedReservations').html(getAllowedReservationsForSelectedresourceGroup());
                if (getAllowedReservationsForSelectedresourceGroup() >= 0) {
                    showAllowedReservationsInfo();
                } else {
                    hideAllowedReservationsInfo();
                }
                $('.resultCaption').show();
                $('#resultTable-box').addClass('has-separator');
            } else {
                $('#resultTable').hide();
                $('.resultCaption').hide();
                $('#resultTable-box').removeClass('has-separator');
            }
            $('#SaveTable').hide();
            $('#saveBtn').hide();
        };

        var searchAvailableSlotsSuccess = function (response) {
            response.Days.forEach(function (day) {
                var dateString = day.Date;
                day.Date = parseJsonDate(dateString);
            });

            clearResultTable();

            var filterForExternal = !response.IsTransporter && !response.IsInternal;

            var slotsOnFirstSlotDate = response.Days[0].TimeSlots;
            if (slotsOnFirstSlotDate.length)
                setupResultTable(slotsOnFirstSlotDate, filterForExternal);

            if (response.Days.length > 1) {
                TimeBookingFunction.clearContentToModal('#dialogArea');
                var dayFullyBookedContent =
                    gro.modules.timeBookingPage.getDayFullyBookedModalContent(response.Days[1]);
                TimeBookingFunction.fillContentToModal(
                    '#dialogArea',
                    'Dag fullbokad',
                    dayFullyBookedContent,
                    true,
                    dialogType.info
                );

                bindFullyBookedModalButtons(response.Days[1], filterForExternal);
            } else if (!slotsOnFirstSlotDate.length) {
                TimeBookingFunction.clearContentToModal('#dialogArea');
                var noSlotsFoundContent = gro.modules.timeBookingPage.getNoSlotsFoundModalContent();
                TimeBookingFunction.fillContentToModal(
                    '#dialogArea',
                    'Inga tider hittades',
                    noSlotsFoundContent,
                    true,
                    dialogType.info
                );
                bindCloseModalButton();
            }

            if (response.Days.length) {
                $('#searchAvailableSlotsBtn').parent().removeClass('disabled-btn');
            } else {
                $('#searchAvailableSlotsBtn').parent().addClass('disabled-btn');
            }

            if (response !== '') {
                $(document).trigger('enhance.tablesaw');
                showHideTimebookingTable(true);
            } else {
                showHideTimebookingTable(false);
            }
            hookupEventsForTimeCheckboxes();

            //--- Transfer searchText to lower part of page.
            $('#IDLevnr_StartValue').val($('#searchFieldTxt').val());
            $('#IDLevnr').val($('#searchFieldTxt').val());
        };
        clearResultTable();
        if (validateRequiredFieldsForSearch()) {
            UpdateAllowedReservations();
            TimeBookingFunction.blockUI();
            var resourceGroup = getSelectedResourceGroupId();
            var selectedDateValue = $('#selectedDate').val();
            var agreementDriedUnDriedValue = $('#agreementDriedUnDried').val();
            var articlesValue = getSelectedArticle();
            var quantityTxtValue = $('#quantityTxt').val();
            var loadOrUnloadValue = $("input[name='loadOrUnloadRad']:checked").val();
            var vehicleTypeValue = $('#vehicleTypeDrp').attr('data-value');
            var referenceType = getReferenceType();
            var customerNo = $('#customerNo').val();
            var ignoreSort = getIgnoreSort();

            if (
                resourceGroup != '' &&
                selectedDateValue != '' &&
                quantityTxtValue != '' &&
                (articlesValue != '' || argementValue != '')
            ) {
                var parameters = {
                    resourceGroupId: resourceGroup,
                    selectedDate: selectedDateValue,
                    article: articlesValue,
                    qty: quantityTxtValue,
                    loadUnload: loadOrUnloadValue,
                    vehicleType: vehicleTypeValue,
                    driedUnDried: agreementDriedUnDriedValue,
                    customerNo: customerNo,
                    searchType: referenceType,
                    ignoreSort: ignoreSort,
                    __RequestVerificationToken: getRequestToken(),
                };
                $.ajax({
                    type: 'POST',
                    url: '/api/time-booking/SearchAvailableSlots',
                    dataType: 'json',
                    data: parameters,
                    success: function (response) {
                        setBackupArticle(response.BackupArticle);
                        searchAvailableSlotsSuccess(response.Calendar);
                        TimeBookingFunction.unBlockUI();
                    },
                    error: function (response) {
                        TimeBookingFunction.unBlockUI();
                        showHideTimebookingTable(false);
                        alert('Error');
                    },
                });
            }
        }
    };

    var UpdateAllowedReservations = function () {
        var currentlyAllowed = getAllowedReservationsForSelectedresourceGroup();

        currentlyAllowed -= getDesiredReservations().length;

        if (currentlyAllowed < 0) {
            hideAllowedReservationsInfo();
        }
        $('#allowedReservations').html(currentlyAllowed);
        if (currentlyAllowed == 0) {
            DisableUncheckedTimeSlots();
        } else {
            EnableUncheckedTimeSlots();
        }
    };

    var DisableUncheckedTimeSlots = function () {
        $('.bookingRows').each(function () {
            if ($(this).prop('checked') == false) {
                $(this).prop('disabled', true);
            }
        });
    };

    var EnableUncheckedTimeSlots = function () {
        $('.bookingRows').each(function () {
            if ($(this).prop('checked') == false) {
                $(this).prop('disabled', false);
            }
        });
    };

    var validateFieldsForReservation = function (isUpdate) {
        var arr = [];

        if ($.trim($('#quantityTxt').val()) == '') {
            arr[arr.length] = '<li>Kvantitet saknar värde.</li>';
        }

        var quantityValue = parseInt($.trim($('#quantityTxt').val()), 10);
        if (isNaN(quantityValue) || quantityValue <= 0) {
            arr[arr.length] = '<li>Kvantitet måste ha ett värde större än 0.</li>';
        }
        if ($.trim($('#customerNo').val()) == '') {
            arr[arr.length] = '<li>Ingen gilltigt kund har valts.</li>';
        }
        if ($.trim($('#vehicleTypeDrp').attr('data-value')) == '') {
            arr[arr.length] = '<li>Fordonstyp saknas.</li>';
        }
        if ($.trim($('#selectedDate').val()) == '') {
            arr[arr.length] = '<li>Datum saknas.</li>';
        }
        if ($.trim(getSelectedArticle()) == '') {
            arr[arr.length] = '<li>Artikel saknas.</li>';
        }
        if ($.trim(getSelectedResourceGroupId()) == '') {
            arr[arr.length] = '<li>Resurs saknas.</li>';
        }
        if (!isUpdate) {
            var resourceValue = getSelectedResourceGroupId();
            var selectedDateValue = $('#selectedDate').val();
            var agrementDriedUnDriedValue = $('#agreementDriedUnDried').val();
            var articlesValue = getSelectedArticle();
            var quantityTxtValue = $('#quantityTxt').val();
            var loadOrUnloadValue = $("input[name='loadOrUnloadRad']:checked").val();
            var vehicleTypeValue = $('#vehicleTypeDrp').attr('data-value');
            var referenceType = getReferenceType();
            var customerNo = $('#customerNo').val();
            var ioNumber = getBookingReference();

            if (
                resourceValue != '' &&
                selectedDateValue != '' &&
                quantityTxtValue != '' &&
                (articlesValue != '' || argementValue != '')
            ) {
                var parameters =
                    "{'resourceGroupId':'" +
                    resourceValue +
                    "', 'selectedDate':'" +
                    selectedDateValue +
                    "', 'article':'" +
                    articlesValue +
                    "', 'qty':'" +
                    quantityTxtValue +
                    "', 'loadunload':'" +
                    loadOrUnloadValue +
                    "', 'vehicleType':'" +
                    vehicleTypeValue +
                    "', 'driedUnDried':'" +
                    agrementDriedUnDriedValue +
                    "', 'customerNo':'" +
                    customerNo +
                    "','searchType':'" +
                    referenceType +
                    "', 'iONumber':'" +
                    ioNumber +
                    "'}";
                $.ajax({
                    type: 'POST',
                    url: '/api/time-booking/ExistBooking',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    data: parameters,
                    async: false,
                    success: function (response) {
                        if (response.IsExistBooking == true) {
                            arr[arr.length] =
                                '<li>Det finns redan en bokning på inköpsordern. Radera befintlig bokning innan du kan skapa en ny!</li>';
                        }
                    },
                    error: function () {
                        alert('ExistBooking');
                    },
                });
            }
        }
        return arr;
    };

    var makeReservation = function () {
        var makereservationContinue = function () {
            var reservations = [];
            var i = 0;
            var innerDTO = {};
            innerDTO['Agrement'] = '';
            innerDTO['SearchValue'] = getBookingReference();
            innerDTO['Qty'] = $('#quantityTxt').val();
            innerDTO['VehicleAssortmentID'] = $('#vehicleTypeDrp').attr('data-value');
            innerDTO['ResourceId'] = getSelectedResourceGroupId();
            innerDTO['Note'] = $('#IDOvrigt').val();

            innerDTO['ReminderInMinutesBefore'] = $('#IDReminder').attr('data-value');
            innerDTO['EmailAddress'] = $('#IDEpost').val();

            innerDTO['CustomerName'] = $('#customerName').val();
            innerDTO['CustomerNo'] = $('#customerNo').val();
            innerDTO['Dried'] = $('#agreementDriedUnDried').val();
            innerDTO['SearchType'] = getReferenceType();
            innerDTO['SelectedDate'] = $('#selectedDate').val();
            innerDTO['Item'] = getSelectedArticle();
            innerDTO['Leveransforsakransnummer'] = $('#IDLevnr').val();
            innerDTO['LicensePlateNo'] = $('#IDReg').val() != null ? $('#IDReg').val() : '';
            innerDTO['MobilePhone'] = $('#IDMobil').val();
            innerDTO['IgnoreSort'] = getIgnoreSort();
            innerDTO['BackupArticle'] = getBackupArticle();
            var Linenumber = $('div').data('Linenumber');
            if (Linenumber == null) {
                Linenumber = 0;
            }
            innerDTO['LineNumber'] = Linenumber;
            var performUnload = $("input:radio[name='loadOrUnloadRad']:checked").val() === '2';

            if (
                TimeBookingFunction.validateSaveTable(
                    innerDTO['EmailAddress'],
                    innerDTO['MobilePhone'],
                    innerDTO['LicensePlateNo'],
                    innerDTO['Leveransforsakransnummer']
                )
            ) {
                var desiredReservations = getDesiredReservations();

                desiredReservations.each(function () {
                    var reservation = {
                        FromTime: $(this).find('.js-From').html(),
                        ResourceId: $(this).find('.js-ResourceId').html(),
                        Unloading: performUnload ? 'true' : 'false',
                        Loading: performUnload ? 'false' : 'true',
                    };
                    reservations.push(reservation);
                });

                if (reservations.length > 0) {
                    innerDTO['Reservations'] = reservations;

                    $.ajax({
                        type: 'POST',
                        url: '/api/time-booking/MakeReservation',
                        dataType: 'json',
                        contentType: 'application/json; charset=utf-8',
                        data: JSON.stringify(innerDTO),

                        success: function (response) {
                            makeReservationSuccess(response.makeReservations);
                        },
                        error: function (response) {
                            makeReservationError(response);
                        },
                    });
                } else {
                    TimeBookingFunction.clearContentToModal('#dialogArea');
                    var content = $('<p></p>').append('Inga tider valda');
                    TimeBookingFunction.fillContentToModal(
                        '#dialogArea',
                        'Tider saknas',
                        content,
                        true
                    );
                }
            }
        };
        var makeReservationSuccess = function (response) {
            var arr = [];
            var msgTitle = '';
            var successCnt = 0;
            var errorCnt = 0;
            arr[arr.length] = '<h4>Bokningar:</h4>';
            arr[arr.length] = '<p>';
            for (var i = 0; i < response.length; i++) {
                if (response[i].Status == 200) {
                    if (i > 0) {
                        arr[arr.length] = '<br /><br />';
                    }
                    arr[arr.length] = response[i].StartDate;
                    arr[arr.length] = ' kl: ';
                    arr[arr.length] = response[i].StartTime;
                    arr[arr.length] = '<br />';
                    arr[arr.length] = response[i].CustomerNo;
                    arr[arr.length] = ' ';
                    arr[arr.length] = response[i].CustomerName;
                    successCnt++;
                } else {
                    errorCnt++;

                    arr[arr.length] = '<h4>Notera att överlappande tider ej kan bokas</h4>';
                    arr[arr.length] = response[i].ErrorMessage;
                    arr[arr.length] = '<br />';
                }
            }
            arr[arr.length] = '<br />';
            arr[arr.length] = '</p>';
            if (errorCnt > 0 && successCnt === 0) {
                msgTitle = 'Fel uppstod vid bokningen';
            } else if (errorCnt > 0 && successCnt > 0) {
                msgTitle = 'Alla bokningar gick inte igenom';
            } else if (errorCnt == 0 && successCnt > 0) {
                msgTitle = 'Bokningar sparade';
            }

            TimeBookingFunction.clearContentToModal('#dialogArea');
            TimeBookingFunction.fillContentToModal(
                '#dialogArea',
                msgTitle,
                arr.join(''),
                true,
                dialogType.success
            );
            $('#saveBtn').addClass('disabled-btn');
            //clearForm();

            UpdateAllowedReservations();

            // do not clear fields if manual booking
            if (getReferenceType() === ReferenceType.CustomerNumber()) {
                searchCustomer(false, true);
                return;
            } else {
                clearDropDown('resourceDrp', 'Välj anläggning');
                $('input[name="loadOrUnloadRad"]').prop('checked', false);
                searchCustomer(false, false);
            }
        };

        var makeReservationError = function (response) {
            TimeBookingFunction.clearContentToModal('#dialogArea');
            TimeBookingFunction.fillContentToModal(
                '#dialogArea',
                'Bokningsfel',
                'Fel uppstod när boking skulle registreras.',
                true,
                dialogType.error
            );
        };

        var errors = validateFieldsForReservation(false);
        if (errors.length > 0) {
            TimeBookingFunction.clearContentToModal('#dialogArea');
            var content = $('<p></p>').append($('<ul></ul>').append(errors.join('')));
            TimeBookingFunction.fillContentToModal(
                '#dialogArea',
                'Uppgifter saknas',
                content,
                true,
                dialogType.error
            );
            return false;
        } else {
            makereservationContinue();
        }
    };

    var searchAvailableSlotAction = function () {
        $('#resultTable').hide();
        $('.resultCaption').hide();
        $('#resultTable-box').removeClass('has-separator');
        $('#SaveTable').hide();
        $('#saveBtn').hide();
        searchAvailableSlots();
    };

    var validateButtonSearchEvent = function () {
        $('#searchFieldTxt')
            .unbind('keyup')
            .keyup(function (event) {
                if ($(this).val() !== '') {
                    $('#searchFieldBtn').removeClass('disabled-btn');

                    // Do search if enter is pressed
                    if (event.keyCode === 13) {
                        $('#searchFieldBtn').click();
                    }
                } else {
                    $('#searchFieldBtn').addClass('disabled-btn');
                }
            });
        $('#searchFieldTxt')
            .unbind('change')
            .change(function () {
                if ($(this).val() !== '') {
                    $('#searchFieldBtn').removeClass('disabled-btn');
                } else {
                    $('#searchFieldBtn').addClass('disabled-btn');
                }
            });
    };

    var makeReservationEvent = function () {
        $('#saveBtn').click(function () {
            makeReservation();
        });
    };

    var updateReservationEvent = function () {
        $('#updateBtn').click(function () {
            updateReservation();
        });
    };

    var validateRequiredFieldsEvent = function () {
        $('#form-time-booking')
            .unbind('change')
            .change(function () {
                if (validateRequiredFieldsForSearch()) {
                    $('#searchAvailableSlotsBtn').parent().removeClass('disabled-btn');
                } else {
                    $('#searchAvailableSlotsBtn').parent().addClass('disabled-btn');
                }
            });
        $('#quantityTxt')
            .unbind('keyup')
            .keyup(function () {
                if (validateRequiredFieldsForSearch()) {
                    $('#searchAvailableSlotsBtn').parent().removeClass('disabled-btn');
                } else {
                    $('#searchAvailableSlotsBtn').parent().addClass('disabled-btn');
                }
            });
        setDropdown($('#resourceDrp').parent(), 'type3');
        $('.searchSlotRequired .dropdown li a').on('click', function () {
            if (validateRequiredFieldsForSearch()) {
                $('#searchAvailableSlotsBtn').parent().removeClass('disabled-btn');
            } else {
                $('#searchAvailableSlotsBtn').parent().addClass('disabled-btn');
            }
        });
        if (validateRequiredFieldsForSearch()) {
            $('#searchAvailableSlotsBtn').parent().removeClass('disabled-btn');
        } else {
            $('#searchAvailableSlotsBtn').parent().addClass('disabled-btn');
        }
    };

    var dropDownResourceClickHandler = function () {
        var resourceValue = $(this).parent().attr('data-value');
        var allowedReservation = $(this).parent().attr('allowedreservations');
        $('#resourceDrp').attr('allowedreservations', allowedReservation);
        searchVehiclesAndItemsByResourceGroup('', resourceValue);

        var regNoMandatory = $(this).parent().attr('regNoMandatory');
        if (regNoMandatory != null) {
            if (regNoMandatory.toLowerCase() == 'true') {
                $('#IDReg').addClass('updateRequiered');
            } else {
                $('#IDReg').removeClass('updateRequiered');
            }
        } else {
            $('#IDReg').removeClass('updateRequiered');
        }
    };

    var searchItemEvent = function () {
        var dropdownResource = $('#resourceDrp .dropdown li a');
        dropdownResource.off('click').on('click', dropDownResourceClickHandler);

        var dropdownArticle = $('#articlesDrp .dropdown li a');
        dropdownArticle.on('click', function () {
            var articleValue = $(this).parent().attr('data-value');
            // TODO, code below is VERY error prone, this has to be rebuilt, magic strings is terrible.
            if (articleValue != null && articleValue != '') {
                var articleArr = articleValue.split('-');
                var driedUndried = articleArr[1];
                if (driedUndried.length >= 2) {
                    driedUndried =
                        driedUndried.substring(0, 1).toUpperCase() + driedUndried.substring(1);
                }
                $('#agreementDriedUnDried').val(driedUndried);
            }
        });

        $('#loadRadio')
            .unbind('change')
            .change(function () {
                searchCustomer(false, true);
            });

        $('#unloadradio')
            .unbind('change')
            .change(function () {
                searchCustomer(false, true);
            });

        $('#selectedDate').change(function () {
            searchVehiclesAndItemsByResourceGroup('', getSelectedResourceGroupId());
        });
    };

    var searchAvailableSlotsEvent = function () {
        $('#searchAvailableSlotsBtn').on('click', function () {
            searchAvailableSlotAction();
        });
    };

    var searchCustomerEvent = function () {
        $('#searchFieldBtn').click(function () {
            clearForm();
            clearBookingInformation();
            hideSelectionOptions();
            searchCustomer(false);
        });
    };

    var bokaSearchTypeChangeEvent = function () {
        $('#search-option > ul > li > a').click(function () {
            clearResultTable();
            $('#SaveTable').hide();
            $('#saveBtn').hide();
            $('#allowedReservationsInfo').hide();
            var placeholderData = $(this).html();
            $('#searchFieldTxt').attr('placeholder', 'Ange ' + placeholderData.toLowerCase());

            // Auto-fill searchfield if empty
            if (!$('#searchFieldTxt').val()) {
                if (
                    isInternal() != 'True' &&
                    isTransporter() != 'True' &&
                    getCurrentlySelectedReferenceType() == ReferenceType.CustomerNumber()
                ) {
                    $('#searchFieldTxt').val($('#LoggedInCustomerNumber').val());
                    searchCustomerWhenLoadPageEvent();
                    $('#searchFieldTxt').attr('disabled', 'disabled');
                } else if (
                    isInternal() == 'True' &&
                    getCurrentlySelectedReferenceType() == ReferenceType.CustomerNumber()
                ) {
                    $('#searchFieldTxt').val($('#LoggedInCustomerNumber').val());
                    searchCustomerWhenLoadPageEvent();
                } else {
                    $('#searchFieldTxt').val('');
                    $('#searchFieldTxt').removeAttr('disabled');
                }
            }

            if (getCurrentlySelectedReferenceType() != ReferenceType.CustomerNumber()) {
                $('#searchFieldTxt').prop('disabled', false);
            }

            //setupLoadUnloadRadios(getCurrentlySelectedReferenceType());
        });
    };

    var updateRadioButtonsAfterSearch = function (element) {
        setupLoadUnloadRadios(getCurrentlySelectedReferenceType(), element.IsLoading);
    };

    var setupLoadUnloadRadios = function (referenceType, load, reload) {
        var $loadRadio = $('#loadRadio');
        var $unloadRadio = $('#unloadradio');

        switch (referenceType) {
            case ReferenceType.PurchaseOrder():
                // Skall alltid vara Lossa, ej Lasta
                $loadRadio.prop('disabled', true).prop('checked', false);
                $unloadRadio.prop('disabled', false).prop('checked', true);
                break;
            case ReferenceType.DistributionOrder():
                // DO: Skall alltid starta på Lasta, kan ha båda. Om Lastning finns = checka lossning
                var checkUnload = load; // load = true om lastning redan finns
                $loadRadio.prop('disabled', false).prop('checked', !checkUnload);
                $unloadRadio.prop('disabled', false).prop('checked', checkUnload);
                break;
            case ReferenceType.ShipmentNumber():
                // Sändning: Skall alltid starta på Lasta, kan ha båda. Om Lastning finns = checka lossning
                var checkUnload = load; // load = true om lastning redan finns
                $loadRadio.prop('disabled', false).prop('checked', !checkUnload);
                $unloadRadio.prop('disabled', false).prop('checked', checkUnload);
                break;
            case ReferenceType.CustomerNumber():
                // Kundnummer: Skall alltid starta på Lasta, kan ha båda
                $loadRadio.prop('disabled', false).prop('checked', true);
                $unloadRadio.prop('disabled', false).prop('checked', false);
                break;
            case ReferenceType.CustomerOrder(): // fall through
            default:
                // Allow both as defaault
                $loadRadio.prop('disabled', false);
                $unloadRadio.prop('disabled', false);
                break;
        }
    };

    var searchCustomerWhenLoadPageEvent = function () {
        if (getBookingReference() != '') {
            $('#searchFieldBtn').removeClass('disabled-btn');
            searchCustomer(false);
        } else {
            $('#searchFieldBtn').addClass('disabled-btn');
        }
    };

    var changeCompanyEvent = function () {
        $("input[name = 'companySelected']").change(function () {
            TimeBookingFunction.blockUI();
            var warehouse = '';
            var company = getCompanySelected();
            getResourceGroups(warehouse, company);
        });
    };

    var getResourceGroups = function (warehouse, company) {
        clearResultTable();
        $('#SaveTable').hide();
        $('#saveBtn').hide();
        $('#allowedReservationsInfo').hide();

        var resourceListLoadSuccess = function (response, warehouseId) {
            var $resourceDropdown = $('#resourceDrp');
            if (response) {
                var resources = typeof response === 'string' ? JSON.parse(response) : response;
                var previouslySelectedResource = getSelectedResourceGroupId();

                // Empty, then fill and re-create the dropdown
                clearDropDown('resourceDrp', 'Välj anläggning');
                $resourceDropdown.find('> ul').append(extractForDropdown('resourceDrp', resources));
                setDropdown($resourceDropdown.parent(), 'type3');
                searchItemEvent(); // re-add event bindings

                if (
                    previouslySelectedResource &&
                    resources.some(function (r) {
                        return r.Value === previouslySelectedResource;
                    })
                ) {
                    $resourceDropdown
                        .find('*[data-value="' + previouslySelectedResource + '"] > a')
                        .click();
                } else {
                    clearDropDown('articlesDrp', 'Välj artikel');
                    clearDropDown('vehicleTypeDrp', 'Välj fordon');
                }

                for (var i = 0; i < resources.length; i++) {
                    if (
                        (warehouseId !== undefined && response[i].M3Id === warehouseId) ||
                        (warehouseId !== undefined && response[i].Value === warehouseId)
                    ) {
                        $resourceDropdown.attr('data-value', resources[i].Value);
                        $resourceDropdown.find('>a').html(resources[i].Display);
                        break;
                    }
                }

                validateRequiredFieldsEvent();
            }
        };

        if (warehouse !== '' && getReferenceType()) {
            var bookingReference = getBookingReference();
            var referenceType = getReferenceType();
            var loading = $("input:radio[name='loadOrUnloadRad']:checked").val() == '1';
            var payload =
                "{'bookingReference':'" +
                bookingReference +
                "', 'referenceType':'" +
                referenceType +
                "', 'warehouseId':'" +
                warehouse +
                "', 'loading':'" +
                loading +
                "'}";
            $.ajax({
                type: 'POST',
                url: '/api/time-booking/LoadResourceGroupsForBookingReference',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data: payload,
                async: false,
                success: function (response) {
                    resourceListLoadSuccess(response.Resource, warehouse);
                },
                error: function () {
                    clearBookingInformation();
                    alert('Error');
                },
            });
        } else {
            $.ajax({
                type: 'POST',
                url: '/api/time-booking/resourceGroupsByCompany',
                dataType: 'json',
                data: {company: company},
                async: false,
                success: function (response) {
                    TimeBookingFunction.unBlockUI();
                    resourceListLoadSuccess(response.Resource, '');
                },
                error: function () {
                    TimeBookingFunction.unBlockUI();
                    clearBookingInformation();
                    alert('Error');
                },
            });
        }
    };

    var init = function () {
        searchItemEvent();
        validateRequiredFieldsEvent();
        searchAvailableSlotsEvent();
        makeReservationEvent();
        updateReservationEvent();
        searchCustomerEvent();
        bokaSearchTypeChangeEvent();
        searchCustomerWhenLoadPageEvent();
        validateButtonSearchEvent();
        changeCompanyEvent();

        if ($('#IDLevnr') && !$('#IDLevnr').val()) {
            $('#IDLevnr').val(getBookingReference());
        }
    };
    return {
        init: init,
        searchItems: searchVehiclesAndItemsByResourceGroup,
        searchAvailableSlotAction: searchAvailableSlotAction,
    };
};

$(document).ready(function () {
    let myTimeBooking = new TimeBookingPage();
    myTimeBooking.init();
    $(document).on('change', 'select', function () {
        //Check whether option with value  exists
        var option = $("option[value='" + this.value + "']", this);
        if (option && option.length > 0) {
            option.attr('selected', true).siblings().removeAttr('selected');
        }
    });
    $(document).trigger('enhance.tablesaw');
});

export { TimeBookingPage as default, DateUtils };